"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("react");
var Notifications_1 = require("./Notifications");
var RemoteGrid_1 = __importDefault(require("../controls/RemoteGrid"));
var constants_1 = require("../controls/Grid/constants");
var recompose_1 = require("recompose");
var react_router_dom_1 = require("react-router-dom");
var lodash_1 = require("lodash");
var fetch_1 = __importDefault(require("../../utils/fetch"));
var Dialog_1 = __importDefault(require("material-ui/Dialog"));
var utils_1 = require("../../utils");
var defaultSubmit = function (url, data) { return __awaiter(_this, void 0, void 0, function () {
    var withId, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                withId = utils_1.idObj(data);
                return [4 /*yield*/, fetch_1.default(url + "/" + withId.id, {
                        method: 'PUT',
                        headers: new Headers({ 'Content-Type': 'application/json' }),
                        body: JSON.stringify(withId),
                    })];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var Dictionary = function (_a) {
    var dialog = _a.dialog, open = _a.open, name = _a.name, url = _a.url, location = _a.location, item = _a.item, sort = _a.sort, editItem = _a.editItem, addItem = _a.addItem, closeItem = _a.closeItem, deleteItems = _a.deleteItems, restoreItems = _a.restoreItems, deactivateItem = _a.deactivateItem, activateItem = _a.activateItem, handleSave = _a.handleSave, Form = _a.Form, oldFormProps = _a.formProps, gridProps = _a.gridProps, dialogProps = _a.dialogProps, rest = __rest(_a, ["dialog", "open", "name", "url", "location", "item", "sort", "editItem", "addItem", "closeItem", "deleteItems", "restoreItems", "deactivateItem", "activateItem", "handleSave", "Form", "formProps", "gridProps", "dialogProps"]);
    var formProps = __assign({ form: name, url: lodash_1.isEmpty(item) ? null : url + "/" + item, item: item, onSubmit: handleSave, closeItem: closeItem, location: location }, oldFormProps);
    var ActionBar = gridProps.ActionBar;
    if (dialog) {
        return (react_1.default.createElement(RemoteGrid_1.default, __assign({ name: name, url: url, sort: sort, order: constants_1.Order.DESC, editItem: editItem, addItem: addItem, deleteItems: deleteItems, restoreItems: restoreItems, deactivateItem: deactivateItem, activateItem: activateItem }, gridProps, { ActionBar: function (grProps) { return (react_1.default.createElement(react_2.Fragment, null,
                react_1.default.createElement(Dialog_1.default, __assign({ className: "dictionaryDialog", contentStyle: { width: '90%', maxWidth: 'none' }, onRequestClose: closeItem, open: open }, dialogProps),
                    react_1.default.createElement(Form, __assign({}, formProps, { onSubmit: function (data, dispatch, props) { return formProps.onSubmit(data, dispatch, props, grProps.refresh); }, closeItem: closeItem }))),
                ActionBar && react_1.default.createElement(ActionBar, __assign({}, grProps)))); } })));
    }
    else {
        if (open) {
            return react_1.default.createElement(Form, __assign({}, formProps));
        }
        else {
            return (react_1.default.createElement(RemoteGrid_1.default, __assign({ name: name, url: url, sort: sort, order: constants_1.Order.DESC, editItem: editItem, addItem: addItem, deleteItems: deleteItems, restoreItems: restoreItems, deactivateItem: deactivateItem, activateItem: activateItem }, gridProps)));
        }
    }
};
exports.default = recompose_1.compose(react_router_dom_1.withRouter, recompose_1.defaultProps({
    closeOnSave: true,
    gridProps: {
        columns: [
            {
                field: 'name',
                label: 'Název',
                type: constants_1.ColumnType.TEXT,
            },
            {
                field: 'active',
                label: 'Aktivní',
                type: constants_1.ColumnType.BOOLEAN,
                width: 100,
            },
        ],
        sort: 'name',
        showNotifications: false,
    },
    urlAddName: 'add',
    urlItemName: 'item',
    onSubmit: defaultSubmit,
    showError: lodash_1.noop,
    showSuccess: lodash_1.noop,
}), recompose_1.branch(function (_a) {
    var showNotifications = _a.gridProps.showNotifications;
    return showNotifications;
}, Notifications_1.withNotifications()), recompose_1.withHandlers({
    addItem: function (_a) {
        var location = _a.location, history = _a.history, urlAddName = _a.urlAddName, dialog = _a.dialog;
        return function (event) {
            if (!dialog && ((event.ctrlKey === true && event.button === 0) || event.button === 1)) {
                window.open(utils_1.setUrlParam(location, urlAddName), '_blank');
            }
            else {
                history.push(utils_1.setUrlParam(location, urlAddName));
            }
        };
    },
    editItem: function (_a) {
        var location = _a.location, history = _a.history, urlItemName = _a.urlItemName, dialog = _a.dialog;
        return function (item, event) {
            if (!dialog && ((event.ctrlKey === true && event.button === 0) || event.button === 1)) {
                window.open(utils_1.setUrlParam(location, urlItemName, item.id), '_blank');
            }
            else {
                history.push(utils_1.setUrlParam(location, urlItemName, item.id));
            }
        };
    },
    closeItem: function (_a) {
        var location = _a.location, history = _a.history, urlItemName = _a.urlItemName, urlAddName = _a.urlAddName;
        return function () {
            var url = utils_1.delUrlParams(location, urlItemName, urlAddName);
            history.push(url);
        };
    },
    handleSave: function (_a) {
        var url = _a.url, onSubmit = _a.onSubmit, history = _a.history, location = _a.location, urlItemName = _a.urlItemName, urlAddName = _a.urlAddName, closeOnSave = _a.closeOnSave, showError = _a.showError, showSuccess = _a.showSuccess;
        return function (values, dispatch, props, gridRefresh) { return __awaiter(_this, void 0, void 0, function () {
            var savedData, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, onSubmit(url, values)];
                    case 1:
                        savedData = _a.sent();
                        showSuccess();
                        if (gridRefresh) {
                            gridRefresh();
                        }
                        if (closeOnSave) {
                            history.push(utils_1.delUrlParams(location, urlItemName, urlAddName));
                        }
                        else {
                            history.push(utils_1.setAndDeleteUrlParams(location, urlItemName, savedData.id, urlAddName));
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        showError();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
    },
    deleteItems: function (_a) {
        var url = _a.url, showError = _a.showError, showSuccess = _a.showSuccess, deleteItems = _a.deleteItems;
        return function (checkedItems, dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var deleteItem, promises, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        deleteItem = function (id) { return (deleteItems ? deleteItems(id) : fetch_1.default(url + "/" + id, { method: 'DELETE' })); };
                        promises = checkedItems.map(function (item) { return deleteItem(item.id); });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, Promise.all(promises)];
                    case 2:
                        _a.sent();
                        showSuccess();
                        return [3 /*break*/, 5];
                    case 3:
                        err_2 = _a.sent();
                        showError();
                        return [3 /*break*/, 5];
                    case 4:
                        dispatch({ type: 'CHECK', payload: [] });
                        dispatch({ type: 'DIRTY' });
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
    },
    restoreItems: function (_a) {
        var url = _a.url, showError = _a.showError, showSuccess = _a.showSuccess;
        return function (checkedItems, dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var restoreItem, promises, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        restoreItem = function (id) { return fetch_1.default(url + "/" + id + "/restore", { method: 'POST' }); };
                        promises = checkedItems.map(function (item) { return restoreItem(item.id); });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, Promise.all(promises)];
                    case 2:
                        _a.sent();
                        showSuccess();
                        return [3 /*break*/, 5];
                    case 3:
                        err_3 = _a.sent();
                        showError();
                        return [3 /*break*/, 5];
                    case 4:
                        dispatch({ type: 'CHECK', payload: [] });
                        dispatch({ type: 'DIRTY' });
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
    },
    deactivateItem: function (_a) {
        var url = _a.url, showError = _a.showError, showSuccess = _a.showSuccess;
        return function (checkedItems, dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var restoreItem, promises, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        restoreItem = function (id) { return fetch_1.default(url + "/" + id + "/active?state=false", { method: 'POST' }); };
                        promises = checkedItems.map(function (item) { return restoreItem(item.id); });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, Promise.all(promises)];
                    case 2:
                        _a.sent();
                        showSuccess();
                        return [3 /*break*/, 5];
                    case 3:
                        err_4 = _a.sent();
                        showError();
                        return [3 /*break*/, 5];
                    case 4:
                        dispatch({ type: 'CHECK', payload: [] });
                        dispatch({ type: 'DIRTY' });
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
    },
    activateItem: function (_a) {
        var url = _a.url, showError = _a.showError, showSuccess = _a.showSuccess;
        return function (checkedItems, dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var restoreItem, promises, err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        restoreItem = function (id) { return fetch_1.default(url + "/" + id + "/active?state=true", { method: 'POST' }); };
                        promises = checkedItems.map(function (item) { return restoreItem(item.id); });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, Promise.all(promises)];
                    case 2:
                        _a.sent();
                        showSuccess();
                        return [3 /*break*/, 5];
                    case 3:
                        err_5 = _a.sent();
                        showError();
                        return [3 /*break*/, 5];
                    case 4:
                        dispatch({ type: 'CHECK', payload: [] });
                        dispatch({ type: 'DIRTY' });
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
    },
}), recompose_1.withProps(function (_a) {
    var location = _a.location, urlAddName = _a.urlAddName, urlItemName = _a.urlItemName;
    var isAddAction = utils_1.existUrlParam(location, urlAddName);
    var item = utils_1.getUrlParam(location, urlItemName);
    var open = isAddAction || !lodash_1.isEmpty(item);
    return {
        item: item,
        open: open,
    };
}))(Dictionary);
//# sourceMappingURL=Dictionary.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/app/Dictionary.js
// module id = 44
// module chunks = 0